import styled from 'styled-components'

import count_icon from './icons/icons_count.png'
import area_icon from './icons/icons_area.png'
import power_icon from './icons/icons_power.png'
import count_dm_icon from './icons/icons_count_dm.png'
import area_dm_icon from './icons/icons_area_dm.png'
import power_dm_icon from './icons/icons_power_dm.png'
import house_icon from './icons/icons_house.png'
import house_dm_icon from './icons/icons_houes_dm.png'
import { useMFContext } from 'components/MFHelpers'
import { useRef } from 'react'

function getUnitAndValue(val: number) {
  // val Shpould be in kWh
  console.log(val)
  if (val < 1000) {
    return { value: val, unit: 'kWh' }
  } else if (val < 1000000) {
    return { value: val / 1000, unit: 'MWh' }
  } else {
    return { value: val / 1000000, unit: 'GWh' }
  }
}

const StatsDisplay = ({
  data,
  name,
}: {
  data: { power: number; count: number; ratio: number }
  name: string
}) => {
  const { colorMode ,_t} = useMFContext()
  const ref = useRef(null)
  var power = getUnitAndValue(data.power*1000)
  return (
    <StatsDisplayContainer
      ref={ref}
      style={{
        boxShadow:
          colorMode === 'light'
            ? '0 5px 15px 0 rgba(0, 0, 0, 0.1)'
            : '0 5px 15px 0 rgba(255, 255, 255, 0.1)',
      }}
    >
      <TextContainer>
        {_t("muni")}
        <div>
          <b>{name}</b>
        </div>
      </TextContainer>
      {data.count > 0 && (
        <>
          <StatsContainer>
            <Entry>
              <img src={colorMode === 'light' ? count_icon : count_dm_icon} />
              <div>
                <b>{formatNumber(data.count, 0)}</b>
                <div>{_t("solars")}</div>
              </div>
            </Entry>
            <Entry>
              <img src={colorMode === 'light' ? area_icon : area_dm_icon} />
              <div>
                <b>{formatNumber(data.ratio)}%</b>
                <div>{_t("used_potential")}</div>
              </div>
            </Entry>
          </StatsContainer>
          <StatsContainer>
            <Entry>
              <img src={colorMode === 'light' ? power_icon : power_dm_icon} />
              <div>
                <b>
                  {formatNumber(power.value, 0)} {power.unit}
                </b>
                <div>{_t("per_year")}</div>
              </div>
            </Entry>
            <Entry>
              <img src={colorMode === 'light' ? house_icon : house_dm_icon} />
              <div>
                <div>{_t("energy_for")}</div>
                <b>{formatNumber((data.power * 950) / 5000, 0)} {_t("households")}</b>
              </div>
            </Entry>
          </StatsContainer>
        </>
      )}
      {data.count === 0 && (
        <div style={{textAlign:"left",width:"100%",fontSize:"14px"}}>
          {_t("no_solar_data")}
        </div>
      )}
    </StatsDisplayContainer>
  )
}
const StatsDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  flex-wrap: wrap;
  padding: 20px;
  position: relative;
  z-index: 1005;
  background-color: var(--site-background);
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  gap: 10px;
  @media (max-width: 768px) {
    z-index: 1;
  }
`

function formatNumber(number: number, decimals: number = 1) {
  let show = number.toFixed(decimals).replace('.', ',')
  if (number > 9999) {
    show = number.toLocaleString('de-CH', {
      maximumFractionDigits: decimals,
      minimumFractionDigits: decimals,
    })
  }
  return show
}

export default StatsDisplay

const StatsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: var(--font-sans-serif);
  font-size: 14px;
  gap: 20px;

  width: 100%;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 10px;
  }
`

const TextContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex: 0 0 100%;
  font-size: 13px;
  font-family: var(--font-sans-serif);
  b {
    font-size: 22px;
  }
`

const Entry = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 1.2em;
  flex: 0 0 50%;
  img {
    max-width: 60px;
    margin-right: 10px;
  }

  @media (max-width: 768px) {
    flex: 0 0 100%;
    img {
      max-width: 40px;
    }
  }
`
